import React from 'react';
import { DataSiteEmailTrackingGroupedRecordStatus } from '$/core/enums';

interface StatusCardsProps {
  statusCounts: Record<string, number>;
  selectedStatus: DataSiteEmailTrackingGroupedRecordStatus | null;
  onStatusClick: (status: DataSiteEmailTrackingGroupedRecordStatus | null) => void;
}

const StatusCards: React.FC<StatusCardsProps> = ({ statusCounts, selectedStatus, onStatusClick }) => {
  const openTasksCount = Object.values(DataSiteEmailTrackingGroupedRecordStatus)
    .filter(s => s !== DataSiteEmailTrackingGroupedRecordStatus.Complete)
    .reduce((sum, s) => sum + (statusCounts[s] || 0), 0);

  const statusConfigs: Array<{ status: DataSiteEmailTrackingGroupedRecordStatus | null; label: string }> = [
    {
      status: null,
      label: 'Open Tasks',
    },
    {
      status: DataSiteEmailTrackingGroupedRecordStatus.Received,
      label: 'Received',
    },
    {
      status: DataSiteEmailTrackingGroupedRecordStatus.PendingReview,
      label: 'Pending Review',
    },
    {
      status: DataSiteEmailTrackingGroupedRecordStatus.InProgress,
      label: 'In Progress',
    },
    {
      status: DataSiteEmailTrackingGroupedRecordStatus.OpsReview,
      label: 'Ops Review',
    },
    {
      status: DataSiteEmailTrackingGroupedRecordStatus.Complete,
      label: 'Complete',
    },
  ];

  const getCount = (status: DataSiteEmailTrackingGroupedRecordStatus | null) => {
    if (status === null) return openTasksCount;
    return statusCounts[status] || 0;
  };

  return (
    <div className="workflow_management_cards">
      {statusConfigs.map(config => (
        <div
          key={config.status ?? 'open-tasks'}
          className={`workflow_management_card ${selectedStatus === config.status ? 'active' : ''}`}
          onClick={() => onStatusClick(config.status)}>
          <span>{config.label}</span>
          <span className="workflow_management_secondary_color">{getCount(config.status)}</span>
        </div>
      ))}
    </div>
  );
};

export default StatusCards;
